import { render } from "./LabBench.vue?vue&type=template&id=454d376a&scoped=true"
import script from "./LabBench.vue?vue&type=script&lang=js"
export * from "./LabBench.vue?vue&type=script&lang=js"

import "./LabBench.vue?vue&type=style&index=0&id=454d376a&scoped=true&lang=css"
import "../../styles/notifications.scss?vue&type=style&index=1&lang=scss"
import "../../styles/LabBench.scss?vue&type=style&index=2&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454d376a"]])

export default __exports__